import { __require as s } from "./main12.js";
var e, t;
function q() {
  if (t) return e;
  t = 1;
  var u = s();
  function i(r, a, n) {
    return r == null ? r : u(r, a, n);
  }
  return e = i, e;
}
export {
  q as __require
};
